import { message } from 'antd'
import { RequisitionsApi } from '../../../api/Corporates/Requisitions'
import RequisitionsImport from '../../../components/Corporate/Requisitions/RequisitionsImport'
import useModalData from '../../../elements/Hooks/useModalData'
import { pick } from 'lodash'
import React from 'react'

function RequisitionsImportCont(props) {
  const { requisition, fetch } = props

  const {
    // object: controlledDoc,
    // setObject: setControlledDoc,
    visible,
    modalType,
    submitting,
    setSubmitting,
    formRef,
    onShow,
    onCancel,
    checkForm,
  } = useModalData()

  async function submit() {
    console.log('clicked')
    const newObject = await checkForm()
    setSubmitting(true)
    try {
      await RequisitionsApi.importLines({
        ...newObject,
        requisition: pick(requisition, '_id'),
      })
      onCancel()
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  return (
    <RequisitionsImport
      {...{
        requisition,
        visible,
        modalType,
        submitting,
        submit,
        formRef,
        onShow,
        onCancel,
      }}
    />
  )
}

export default RequisitionsImportCont
